<template>
  <v-dialog
    v-model="value"
    content-class="resource__modal"
    @click:outside="$emit('input', false)"
  >
    <v-card
      class="mx-auto"
      max-height="80vh"
    >
      <header :class="{ graduation__header: !resourceLocale.image }">
        <v-img :src="resourceLocale.image"
               class="white--text align-end"
               v-if="resourceLocale.image"
        />
        <img :src="JLearnImg"
             class="white--text align-end graduation_hat"
             :alt="$t('appUser.resourceModal.imageAlt')"
             v-else
        />
      </header>

      <v-card-text class="text--primary">
        <v-card-title>{{ resourceLocale.title }}</v-card-title>
        <p v-html="resourceLocale.description"></p>
      </v-card-text>

      <v-card-actions>
        <a :href="resourceLocale.link" target='_blank'>
          <v-btn color="valid">
            {{ $t('appUser.resourceModal.buttons.newTab') }}
          </v-btn>
        </a>
        <div
          v-if="!resourceLocale.attendance.isCompleted && !resourceLocale.attendance.isDiscarded">
          <v-btn color="other1" @click.stop="onUpdateTracker('complete')">
            {{ $t('appUser.resourceModal.buttons.finishTag') }}
          </v-btn>
          <v-btn color="other2" @click.stop="onUpdateTracker('discard')">
            {{ $t('appUser.resourceModal.buttons.discardTag') }}
          </v-btn>
        </div>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ResourceModal',
  props: {
    value: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    JLearnImg: null
  }),
  computed: {
    ...mapGetters('Resources', [
      'resourceDisplayed'
    ]),
    resourceLocale () {
      let resource = {
        image: '',
        title: '',
        description: '',
        attendance: {
          isCompleted: false,
          isDiscarded: false
        }
      }

      return Object.entries(this.resourceDisplayed).length === 0 ? resource : this.resourceDisplayed
    }
  },
  methods: {
    ...mapActions('Resources', [
      'updateTracker'
    ]),
    async onUpdateTracker (status) {
      await this.updateTracker({
        resourceId: this.resourceDisplayed.id,
        status
      })

      this.$emit('input', false)
    }
  }
}
</script>

<style lang="scss">
  @import "../../../assets/style/responsive";

  .resource__modal {
    width: 90vw;

    @media all and (min-width: $small) {
      width: 75vw;
    }

    @media all and (min-width: $medium) {
      width: 50vw;
    }

    .v-card {
      .v-image {
        max-height: 100px;

        @media all and (min-width: $small) {
          max-height: 150px;
        }

        @media all and (min-width: $medium) {
          max-height: 200px;
        }
      }

      header.graduation__header {
        background-color: #293a48;
        display: flex;
        justify-content: center;

        .graduation_hat {
          height: 200px;
          margin: 5px 0;
          background-color: #293a48;
        }
      }

      .v-card__text {
        .v-card__title {
          font-size: 16px;
          line-height: 18px;
          padding: 0;
          word-break: normal;
          font-weight: bold;
          margin: 5px 0 10px 0;
          display: flex;
          justify-content: center;

          @media all and (min-width: $small) {
            font-size: 20px;
            line-height: 22px;
            justify-content: flex-start;
          }

          @media all and (min-width: $medium) {
            font-size: 24px;
            line-height: 26px;
          }
        }

        p {
          text-align: center;

          @media all and (min-width: $small) {
            font-size: 16px;
            text-align: left;
          }
        }
      }

      .v-card__actions {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;

        @media all and (min-width: $large) {
          flex-direction: row;
        }

        div {
          display: flex;
          flex-direction: column;
          width: 100%;

          button {
            margin-bottom: 5px;
          }

          button:last-child.v-btn {
            margin: 0;
          }

          @media all and (min-width: $large) {
            width: auto;
            margin: 0;
            flex-direction: row;

            button:last-child.v-btn {
              margin-left: 6px;
            }
          }
        }

        a {
          text-decoration: none;
          width: 100%;
          margin-bottom: 5px;

          @media all and (min-width: $large) {
            width: auto;
            margin: 0;
          }

          button {
            width: 100%;
          }
        }
      }
    }
  }
</style>
